export enum EmailRequirement {
  emailExistsNotAllowed = 'email-exists-not-allowed',
  freeEmailNotAllowed = 'free-email-not-allowed',
  disposableEmailNotAllowed = 'disposable-email-not-allowed',
  validationCheckError = 'email-validation-error',
}
